import React, { ReactElement } from 'react';
import { useAppDispatch } from '../../store/store';
import { setAccountAddToWallet } from '../../store/addToWalletSlice';
import { onSelectionAddToWallet } from './AddToWalletIntegrationSDK';
import { captureAnalyticsDataAttributes } from '../../utils/analytics/analyticsDispatchers';

const AddToWalletButton = ({
  buttonImgSrc,
  ariaLabel,
  altTag,
  buttonId,
  dataReason,
  dataType,
  tabIndex,
  dataTestId,
  walletType,
  clientId,
  productType,
}: WalletButton): ReactElement => {
  const dispatch = useAppDispatch();
  const addToWalletAction = (event: any) => {
    captureAnalyticsDataAttributes(event);
    dispatch(
      setAccountAddToWallet({
        walletType,
        clientId,
        productType,
      }),
    );
    onSelectionAddToWallet(walletType);
  };

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      id={buttonId}
      data-testid={dataTestId}
      data-type={dataType}
      data-reason={dataReason}
      data-object="addToWalletButton"
      onClick={addToWalletAction}
    >
      <img src={buttonImgSrc} alt={altTag} className="wallet-image" />
    </button>
  );
};

export default AddToWalletButton;
